
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#F7941E","cx":"10","cy":"10","r":"10"}}),_c('path',{attrs:{"d":"M8.7 14.485c0-.893.718-1.54 1.628-1.54.927 0 1.662.647 1.662 1.54s-.735 1.558-1.662 1.558c-.91 0-1.628-.665-1.628-1.558zm5.268-6.265c0 1.313-.98 2.17-1.716 3.08-.402.473-.49.752-.507 1.015H9.033c.017-.63.192-1.032.857-1.855.63-.77 1.225-1.26 1.225-1.96 0-.595-.402-.98-.98-.98-.665 0-1.015.508-1.05 1.068H6.25C6.46 6.593 7.825 5 10.24 5c2.24 0 3.727 1.225 3.727 3.22z","fill":"#FFF"}})])])
      }
    
      }
    